import { Button, message, Tooltip } from 'antd'
import { useAccount } from 'wagmi'

import { describeV3ContractError } from 'extends/pto-v3.extend'
import { useDeployPtoV3 } from 'hooks/pto-v3/use-deploy-pto-v3'
import { onCloseModalProcessing, onOpenModalProcessing } from 'stores/modal.store'
import { logError } from 'utils/logger'

/**
 * PTO v3 - deploy the ERC-3643 PTO (PTOOrchestrator.createPTO) with BE-built calldata
 * for a PTO that has been created without a contract yet.
 */
const ButtonDeployContract = ({
  id,
  onSuccess,
}: {
  id: string
  onSuccess?: () => Promise<void> | void
}) => {
  const { address } = useAccount()
  const { isAgent, deployPto, reportDeployed } = useDeployPtoV3()

  const handleDeploy = async (e: React.MouseEvent) => {
    e.preventDefault()

    if (!address) {
      message.error('Please connect wallet!')
      return
    }
    if (isAgent === false) {
      message.error('Your wallet is not an agent of the PTO Orchestrator!')
      return
    }

    try {
      onOpenModalProcessing()
      const result = await deployPto(address, id)
      await reportDeployed(id, result)
      await onSuccess?.()
      message.success('Deploy PTO successfully')
    } catch (error) {
      const errorMessage = describeV3ContractError(error)
      message.error(errorMessage || 'Error while deploying PTO')
      logError('Deploy PTO v3 error:', error)
    } finally {
      onCloseModalProcessing()
    }
  }

  if (!address) return null

  return (
    <Tooltip title={isAgent === false ? 'Connected wallet is not an orchestrator agent' : ''}>
      <Button type="default" onClick={handleDeploy} disabled={isAgent === false}>
        Deploy PTO
      </Button>
    </Tooltip>
  )
}

export default ButtonDeployContract
